import type { RootOptions } from 'react-dom/client';

export const SELF_REPORTING_ERROR_BOUNDARY = Symbol('self-reporting-error-boundary');

type CaughtErrorHandler = NonNullable<RootOptions['onCaughtError']>;

export function skipSelfReportingErrorBoundaries(handler: CaughtErrorHandler): CaughtErrorHandler {
  return (error, errorInfo) => {
    const boundary = errorInfo.errorBoundary as
      | { [SELF_REPORTING_ERROR_BOUNDARY]?: boolean }
      | undefined;

    if (boundary?.[SELF_REPORTING_ERROR_BOUNDARY]) {
      return;
    }

    handler(error, errorInfo);
  };
}
